/**
 * @file Bind click event delegate for button click animation
 *
 * @author michael.schmid@notch-interactive.com, christian.sany@notch-interactive.com
 *
 * @mcomponent component/buttons
 */

const instance = {},
    settings = {},
    defaults = {
        button: '.button',
        buttonClickedClass: 'button--clicked'
    },
    touchEventSupport = document.documentElement.classList.contains('touchevents'),

    handler = (e) => {
        const trigger = e.target.closest(settings.button);

        // Check if trigger is found
        if (trigger !== null) {
            trigger.classList.add(settings.buttonClickedClass);
            if (!touchEventSupport) {
                setTimeout(() => {
                    trigger.classList.remove(settings.buttonClickedClass);
                }, 400);
            }
        }
    };

/**
 * Initialize module
 *
 * @param {object} options - Override default settings with options object.
 * @return {object} Instance of the module.
 */
instance.init = (options) => {
    Object.assign(settings, defaults, options);

    // Add delegate to document
    document.addEventListener('click', handler);

    return instance;
};

/**
 * Destroy module
 *
 * @return {object} Instance of the module.
 */
instance.destroy = () => {

    // Remove delegate to document
    document.removeEventListener('click', handler);

    return instance;
};

export default instance;
